import {useQuery} from '@tanstack/react-query';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {QUERY_KEYS} from '../../../../utils/queryKeys';
import Modal from '../../../../incase-domain/components/modals/directory/Modal';
import VerticalNavigation from '../../../../incase-domain/components/verticalNavigation/VerticalNavigation';
import {fetchCalculators} from '../../../../service/calculator.service';
import CalculatorDisplay from '../../../elements/calculator/CalculatorDisplay';

interface CalculatorSelectionModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (calculatorId: string) => void;
}

function CalculatorSelectionModal({isOpen, onClose, onConfirm}: CalculatorSelectionModalProps): JSX.Element {
    const {t} = useTranslation();
    const [selectedCalculatorIndex, setSelectedCalculatorIndex] = useState(0);

    const {data: calculators = []} = useQuery(QUERY_KEYS.calculator.lists(), () => fetchCalculators());

    const handleConfirm = (): void => {
        if (!calculators.length) return;
        if (!calculators[selectedCalculatorIndex]?._id) return;

        onConfirm(calculators[selectedCalculatorIndex]._id as string);
    };

    return (
        <Modal
            isOpen={isOpen}
            onCancel={onClose}
            header={t('presEditPage.editSidebar.elements.calculator.choose')}
            description={t('presEditPage.editSidebar.elements.calculator.chooseDescription')}
            icon="solar:calculator-bold"
            showCancel
            cancelText={t('common.dismiss')}
            showConfirm
            confirmText={t('common.add')}
            onConfirm={handleConfirm}
            confirmDisabled={!calculators.length}
            size="lg"
        >
            <div className="c-calculatorSelectionModal">
                {calculators.length ? (
                    <>
                        <div className="c-calculatorSelectionModal__navigation">
                            <VerticalNavigation
                                items={calculators.map((calculator) => ({
                                    label: calculator.name,
                                    icon: 'solar:calculator-linear',
                                }))}
                                initialIndex={selectedCalculatorIndex}
                                onChange={setSelectedCalculatorIndex}
                            />
                        </div>
                        <div className="c-calculatorSelectionModal__preview">
                            <CalculatorDisplay calculator={calculators[selectedCalculatorIndex]} readOnly />
                        </div>
                    </>
                ) : (
                    <div className="c-calculatorSelectionModal__empty">
                        {t('presEditPage.editSidebar.elements.calculator.noCalculators')}
                    </div>
                )}
            </div>
        </Modal>
    );
}

export default CalculatorSelectionModal;
